import { ManufacturingLifecycleStatus } from '../../constants/manufacturing-lifecycle-status.js';
/** The statuses at which a ticket's planned quantity may still be edited. */
export const WORK_ORDER_PLANNABLE_STATUS_IDS = [
    ManufacturingLifecycleStatus.ISSUED,
    ManufacturingLifecycleStatus.PICK,
];
//# sourceMappingURL=work-order-plannable-status-ids.js.map